<template>
  <div class="space-between-y">
    <el-dialog width="260px" title="角色更新" :visible.sync="updateRole.dialog" @close="updateRole.id=''">
      <role-update :id="updateRole.id" v-if="updateRole.dialog" @updated="handleUpdated"></role-update>
    </el-dialog>

    <el-dialog width="560px" title="权限配置" :visible.sync="accessSetup.dialog">
      <role-access-update :role-id="accessSetup.id" v-if="accessSetup.dialog"></role-access-update>
    </el-dialog>

    <div>
      <el-button type="primary" @click="updateRole.dialog = true">新增角色</el-button>
    </div>

    <el-table :data="roles" stripe border>
      <el-table-column prop="id" label="角色编号"></el-table-column>
      <el-table-column prop="name" label="角色名称"></el-table-column>
      <el-table-column prop="desc" label="说明"></el-table-column>
      <el-table-column label="操作" width="120">
        <template v-slot:default="scope">
          <el-button size="mini" type="text" @click="handlerUpdate(scope.row.id)">更新</el-button>
          <el-button size="mini" type="text" @click="handlerRoleAccessUpdate(scope.row.id)">配置权限</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import RoleUpdate from "@/components/sysSet/access/new/RoleUpdate.vue";
import {role} from "@/api/role";
import RoleAccessUpdate from "@/components/sysSet/access/new/RoleAccessUpdate.vue";

export default {
  name: 'AccessV2',
  components: {RoleAccessUpdate, RoleUpdate},

  data() {
    return {
      updateRole: {
        dialog: false,
        id: "",
      },

      accessSetup: {
        dialog: false,
        id: "",
      },

      roles: [],


    };
  },

  created() {
    this.getData();
  },

  methods: {
    handlerRoleAccessUpdate(id) {
      this.accessSetup.id = id;
      this.accessSetup.dialog = true;
    },

    handlerUpdate(id) {
      console.log(id)
      this.updateRole.id = id;
      this.updateRole.dialog = true;
    },


    handleUpdated() {
      this.getData();
      this.updateRole.dialog = false;
      this.updateRole.id = "";
    },


    getData() {
      role.listAll().then(list => {
        this.roles = list;
      })

    },

  },


};
</script>

<style scoped>
</style>
